import { TT911 } from '@rsos/capstone/src/constants/capabilities';
import useHasCapability from './useHasCapability';

/**
 * Whether the current PSAP has the Text-to-911 (TCAPI) capability enabled.
 */
function useIsTT911Enabled(): boolean {
  return !!useHasCapability(TT911).hasCapability;
}

export default useIsTT911Enabled;
